export default __webpack_public_path__ + "static/media/settings-icon.f7064e3d.svg";